import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ORDERSTATUSMESSAGECARDBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "content",
  "text",
  { type: 'separator' },
  "display_only_if_payment_methods",
  "enabled_for_payment_methods",
  { type: 'separator' },
  "display_only_if_types",
  "enabled_for_types",
  { type: 'separator' },
  "display_if_order_amount_equal_zero",
  { type: 'separator' },
  "background_color",
  "text_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  orderStatusMessageCardBlockDescriptor: _generatedOrderStatusMessageCardBlockDescriptor,
  orderStatusMessageCardBlockBlocDefinition,
  orderStatusMessageCardBlockDashboardLayout,
  orderStatusMessageCardBlockConfig,
  orderStatusMessageCardBlockResolveConfig,
  orderStatusMessageCardBlockProperties,
} = doodBlockConfig(
  {
    name: "Message card",
    componentType: 'OrderStatusMessageCardBlockComponent',
    category: 'content',
    description: "Message card.",
    keywords: [],
    allowedIn: [
      { bloc: 'OrderStatusPageComponent', slot: '*' },
    ],


    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.order-status-message-card.title.label",
      }
    }),
    content: propertyValue({
      type: 'wysiwyg',
      value: '',
      options: {
        label: "pages.blocks.order-status-message-card.content.label",
      }
    }),
    text: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.order-status-message-card.text.label",
        help: "pages.blocks.order-status-message-card.text.help",
      }
    }),
    display_only_if_payment_methods: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.order-status-message-card.display-only-if-payment-methods.label",
      }
    }),
    enabled_for_payment_methods: propertyValue({
      type: 'select',
      value: "",
      options: {
        label: "pages.blocks.order-status-message-card.enabled-for-payment-methods.label",
        multiple: true,
        choices: [
          {
            value: "ON_SITE_WITHOUT_DEPOSIT",
            label: "pages.blocks.order-status-message-card.enabled-for-payment-methods.options.ON_SITE_WITHOUT_DEPOSIT",
          },
          {
            value: "HOUSE_ACCOUNT",
            label: "pages.blocks.order-status-message-card.enabled-for-payment-methods.options.HOUSE_ACCOUNT",
          },
          {
            value: "ONSITE",
            label: "pages.blocks.order-status-message-card.enabled-for-payment-methods.options.ONSITE",
          },
          {
            value: "STRIPE",
            label: "pages.blocks.order-status-message-card.enabled-for-payment-methods.options.STRIPE",
          },
          {
            value: "STRIPE_TERMINAL",
            label: "pages.blocks.order-status-message-card.enabled-for-payment-methods.options.STRIPE_TERMINAL",
          },
          {
            value: "LYDIA",
            label: "pages.blocks.order-status-message-card.enabled-for-payment-methods.options.LYDIA",
          },
          {
            value: "PAYGREEN",
            label: "pages.blocks.order-status-message-card.enabled-for-payment-methods.options.PAYGREEN",
          },
          {
            value: "EDENRED",
            label: "pages.blocks.order-status-message-card.enabled-for-payment-methods.options.EDENRED",
          },
          {
            value: "ADYEN",
            label: "pages.blocks.order-status-message-card.enabled-for-payment-methods.options.ADYEN",
          },
          {
            value: "CMI",
            label: "pages.blocks.order-status-message-card.enabled-for-payment-methods.options.CMI",
          },
          {
            value: "LYDIA",
            label: "pages.blocks.order-status-message-card.enabled-for-payment-methods.options.LYDIA",
          }
        ]
      }
    }),
    display_only_if_types: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.order-status-message-card.display-only-if-types.label",
      }
    }),
    enabled_for_types: propertyValue({
      type: 'select',
      value: "",
      options: {
        label: "pages.blocks.order-status-message-card.enabled-for-types.label",
        multiple: true,
        choices: [
          {
            value: "click-and-collect",
            label: "pages.blocks.order-status-message-card.enabled-for-types.options.click-and-collect",
          },
          {
            value: "delivery",
            label: "pages.blocks.order-status-message-card.enabled-for-types.options.delivery",
          },
          {
            value: "on-site",
            label: "pages.blocks.order-status-message-card.enabled-for-types.options.on-site",
          },
          {
            value: "shipping",
            label: "pages.blocks.order-status-message-card.enabled-for-types.options.shipping",
          },
          {
            value: "eat-in",
            label: "pages.blocks.order-status-message-card.enabled-for-types.options.eat-in",
          }
        ]
      }
    }),
    display_if_order_amount_equal_zero: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.order-status-message-card.display-if-order-amount-equal-zero.label",
        help: "pages.blocks.order-status-message-card.display-if-order-amount-equal-zero.help",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        label: "pages.blocks.order-status-message-card.background-color.label",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        label: "pages.blocks.order-status-message-card.text-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.order-status-message-card.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.order-status-message-card.fieldset.message.label",
            fields: ["title", "content", "text", "background_color", "text_color"],
          },
          {
            legend: "pages.blocks.order-status-message-card.fieldset.payment-methods.label",
            fields: [
              "display_only_if_payment_methods",
              {
                prop: "enabled_for_payment_methods",
                visibleWhen: { display_only_if_payment_methods: true },
              },
            ],
          },
          {
            legend: "pages.blocks.order-status-message-card.fieldset.order-types.label",
            fields: [
              "display_only_if_types",
              {
                prop: "enabled_for_types",
                visibleWhen: { display_only_if_types: true },
              },
            ],
          },
          {
            legend: "pages.blocks.order-status-message-card.fieldset.zero-amount.label",
            fields: ["display_if_order_amount_equal_zero"],
          },
        ],
      },
    ],
  })
);

export function orderStatusMessageCardBlockDescriptor(): IBlockDescriptor;
export function orderStatusMessageCardBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function orderStatusMessageCardBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedOrderStatusMessageCardBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedOrderStatusMessageCardBlockDescriptor, orderStatusMessageCardBlockProperties, fieldOrder);
}

export {
  orderStatusMessageCardBlockBlocDefinition,
  orderStatusMessageCardBlockDashboardLayout,
  orderStatusMessageCardBlockProperties,
  orderStatusMessageCardBlockConfig,
  orderStatusMessageCardBlockResolveConfig,
};

export type OrderStatusMessageCardBlockConfig = typeof orderStatusMessageCardBlockConfig;
